import { useQuery } from '@tanstack/react-query';

import { catalogService } from '../services/catalog.service';
/**
 * Recupera la definición de un catálogo a partir de su identificador
 *
 * @param {string} id Identificador del catálogo por recuperar
 * @return {*} definición del catálogo
 */
export const useCatalog = (id: string) => {
  return useQuery({
    queryKey: ['catalog', id],
    queryFn: () => catalogService.getCatalog(id)
  });
};
